<template>
    <div class="index full-width">
        <transition-group tag="ul" class="bannerList" name="fade" mode="out-in" @mousein="stopBanner">
            <li :key="key" class="bannerItem" v-for="(item,key) in banner" v-show="key === bannerIndex">
                <a :style="{backgroundImage:`url(${item})`}" style="background-position: center"></a>
            </li>
            <div class="control" key="control">
                <ul style="transform: rotate(180deg);">
                    <li class="control-item cursor" :class="{active:key === bannerIndex}" v-for="(i,key) in banner"
                        @click="bannerIndex = key">

                    </li>
                </ul>
            </div>
        </transition-group>
        <div class="welfare full-width">
            <div class="container">
                <img class="tile" src="static/welfare.png" alt="">
                <h1 class="tile-cont">福利发放方案</h1>
                <a class="more-btn" @click="$router.push('/welfare')">
                    <img class="btn" src="static/learnmore2.png" alt="">
                    <img class="btn1" src="static/learnmore.png" alt="">
                </a>
                <div class="welfare-animate">
                    <div class="welfare-item" v-for="(i,k) in welfarebg"
                         :class="{active:select===k}"
                         :style="{backgroundImage:`url(${i})`}"
                         @mouseenter="select = k"
                    >
                        <div class="welfare-content">
                            <p class="tile">{{welfaCont[k].tile}}</p>
                            <img src="static/index-icon-problem-white.png" alt="">
                            <p class="cont1">{{welfaCont[k].cont1}}</p>
                            <img src="static/index-icon-sollution-white.png" alt="">
                            <p class="cont2">{{welfaCont[k].cont2}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business full-width">
            <div class="container">
                <img class="tile" src="static/Business.png" alt="">
                <h1 class="tile-cont">商务礼赠方案</h1>
                <a class="more-btn" @click="$router.push('/gift')">
                    <img class="btn" src="static/learnmore2.png" alt="">
                    <img class="btn1" src="static/learnmore.png" alt="">
                </a>
                <img src="static/swlz.png" alt="">
            </div>
        </div>
        <div class="platform full-width" :style="{backgroundImage:`url('static/index-bg-2.png')`}"
             style="background-position: center">
            <div class="container">
                <img class="tile" src="static/platform.png" alt="">
                <h1 class="tile-cont">多平台接入</h1>
            </div>
            <div class="container clearfix">
                <div class="wave-box">
                    <div class="wave-parent">
                        <div class="wave-child" v-for="i in 6">
                        </div>
                        <div>
                            <div class="set-child" v-for="(i,k) in 6" @mouseenter=" typing(k) ">
                                <img :src="setChild[k]" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="phone" :style="{backgroundImage:`url('static/phone.png')`}">
                    <div class="phone-screen" :style="{backgroundImage:`url(${screen[screenOn]})`}">
                    </div>
                    <p id="typing"></p>
                </div>
            </div>
        </div>
        <div class="case full-width">
            <div class="container">
                <img class="tile" src="static/case.png" alt="">
                <h1 class="tile-cont">信赖，源自于他们的选择</h1>
                <table width="1130">
                    <tr>
                        <td></td>
                        <td><img class="case-img" src="static/case/image0.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image1.png" alt=""></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><img class="case-img" src="static/case/image2.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image3.png" alt=""></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><img class="case-img" src="static/case/image4.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image5.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image6.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image7.png" alt=""></td>
                        <td></td>
                        <td><img class="case-img" src="static/case/image8.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image9.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image10.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image11.png" alt=""></td>
                    </tr>
                    <tr>
                        <td><img class="case-img" src="static/case/image12.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image13.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image14.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image15.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image16.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image17.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image18.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image19.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image20.png" alt=""></td>
                    </tr>
                    <tr>
                        <td><img class="case-img" src="static/case/image21.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image22.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image23.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image24.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image25.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image26.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image27.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image28.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image29.png" alt=""></td>
                    </tr>
                    <tr>
                        <td><img class="case-img move" src="static/case/image30.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image31.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image32.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image33.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image34.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image35.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image36.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image37.png" alt=""></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td><img class="case-img move" src="static/case/image38.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image39.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image40.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image41.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image42.png" alt=""></td>
                        <td><img class="case-img move" src="static/case/image43.png" alt=""></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><img class="case-img" src="static/case/image44.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image45.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image46.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image47.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image48.png" alt=""></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><img class="case-img" src="static/case/image49.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image50.png" alt=""></td>
                        <td><img class="case-img" src="static/case/image51.png" alt=""></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><img class="case-img" src="static/case/image52.png" alt=""></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    var i = 0;
    var str = '';

    function input() {
        var divTyping = document.getElementById('typing');
        if (i <= str.length) {
            divTyping.innerHTML = str.slice(0, i++) + '|';
            window.timer = setTimeout(function () {
                input()
            }, 100);
        }
        else {
            divTyping.innerHTML = str;
            i = 0
        }
    }

    function clear() {
        clearTimeout(window.timer)
    }

    export default {
        name: "index",
        metaInfo: {
            title: '福分通-首页', // set a title
            meta: [{                 // set meta
                name: '福分通',
                content: '专注企业员工福利'
            }]
        },
        data() {
            return {
                select: 0,
                screenOn: 0,
                banner: [
                    'static/homepage/banner2.jpg',
                    'static/homepage/aboutus.png',
                    'static/homepage/banner4.jpg'
                ],
                welfarebg: ['static/bg1.png', 'static/bg2.png', 'static/bg3.png'],
                welfaCont: [
                    {
                        tile: '弹性福利发放方案',
                        cont1: '偶尔需要一些节日福利发放，不想太麻烦？',
                        cont2: '申请企业专属账户，灵活选择福利在线发放。通过积分充值，自定义发放到员工账户，员工自由选购福利商品。'
                    },
                    {
                        tile: '定制专属福利商城',
                        cont1: '通用商城凸显不出企业自身的形象及企业文化？',
                        cont2: '别担心，定制企业的专属商城，支持自定义UI界面，展现企业文化与形象，增强员工归属感；同时支持自有供应商接入，管理更便捷。'
                    },
                    {
                        tile: '海量商品系统直连',
                        cont1: '有商城，但商品不够丰富？',
                        cont2: '福分通作为商品供应商接入，支持定向接口开发对接，系统对接。'
                    }
                ],
                setChild: [
                    'static/index-icon-app.png',
                    'static/index-icon-dingding.png',
                    'static/index-icon-fuwuhao.png',
                    'static/index-icon-oa.png',
                    'static/index-icon-wangzhan.png',
                    'static/index-icon-weixin.png'
                ],
                screen: [
                    'static/app.png',
                    'static/dding.png',
                    'static/fwh.png',
                    'static/oa.png',
                    'static/web.png',
                    'static/wechat.png'
                ],
                notes: [
                    '支持接入企业自由员工福利平台，拥有成熟的对接方案',
                    '转为中小型企业打造的快速沟通、高效协作的即时通讯工具',
                    '业务支持嵌入企业服务号，实现一键登录，企业集中管理',
                    '泛微、云之家等OA办公系统',
                    '企业门户官网，或内部平台网站',
                    '企业微信是专注于企业的沟通工具，与微信共用账号体系'
                ],
                bannerIndex: 0,
                str: '',
                tim: setInterval(() => {
                    if (this.bannerIndex === 0) {
                        this.bannerIndex = this.banner.length - 1;
                        return
                    }
                    this.bannerIndex -= 1
                }, 5000)
            }
        },
        created() {

        },
        methods: {
            stopBanner() {
                this.clearInterval(this.tim)
            },
            typing(k) {
                i = 0;
                this.screenOn = k;
                str = this.notes[k];
                clear();
                input()
            }
        }
    }
</script>

<style scoped lang="stylus">
    .index
        ul.bannerList
            position absolute
            top 0
            width 100%
            min-width 1200px
            height 640px
            z-index 0
            li.bannerItem
                position absolute
                width 100%
                height 640px
                top 0
                left 0
                cursor pointer
                a
                    display block
                    height inherit
                    overflow hidden
                    text-align center
                    background-size cover
        .welfare
            height 870px
            width 100%
            min-width 1200px
            background-color #f2f2f2
            text-align center
            .tile
                display inline-block
                margin-top 60px
            .tile-cont
                margin-top 20px
                font-size 36px
                color black
                font-weight bold
            .container
                padding 0
                .welfare-animate
                    margin-top 47px
                    &:after
                        display block
                        content ''
                        clear both
                    .welfare-content
                        width 380px
                        height 450px
                        margin 0 auto
                        padding 37px 28px
                        .tile
                            display block
                            margin 0 0 30px
                            color white
                            text-align left
                            font-size 20px
                        img
                            display inline-block
                            float left
                            transform translateY(2px)
                        .cont1, .cont2
                            text-align left
                            color white
                            line-height 20px
                            margin-bottom 20px
                            margin-left 30px
                    .welfare-item
                        width 380px
                        height 450px
                        background-position center
                        background-size 420px 480px
                        float left
                        margin-right 10px
                        transition width 0.5s
                        &.active
                            transition width 0.5s
                            width 420px
                            height 480px
                        &:last-child
                            margin-right 0
        .business
            height 756px
            width 100%
            min-width 1200px
            text-align center
            .tile
                display inline-block
                margin-top 60px
            .tile-cont
                margin-top 20px
                font-size 36px
                color black
                font-weight bold
        .platform
            height 900px
            width 100%
            min-width 1200px
            text-align center
            .container
                .wave-box
                    position relative
                    width 800px
                    height 580px
                    float left
                    .wave-parent
                        position relative
                        width 580px
                        height 580px
                        margin 0 auto
                        .wave-child
                            width calc(130px - 5px)
                            height calc(130px - 5px)
                            border-radius 50%
                            box-shadow 0 0 20px #3672af
                            position absolute
                            top 225px
                            left 225px
                            &:first-child
                                animation circle-opacity 2 * 2s infinite linear
                            &:nth-child(1)
                                animation circle-opacity 2 * 2s infinite linear
                                animation-delay 0.4 * 2s
                            &:nth-child(2)
                                animation circle-opacity 2 * 2s infinite linear
                                animation-delay 0.8 * 2s
                            &:nth-child(3)
                                animation circle-opacity 2 * 2s infinite linear
                                animation-delay 1.2 * 2s
                            &:nth-child(4)
                                animation circle-opacity 2 * 2s infinite linear
                                animation-delay 1.6 * 2s
                            &:nth-child(5)
                                animation circle-opacity 2 * 2s infinite linear
                                animation-delay 2 * 2s
                        .set-child
                            position absolute
                            width 75px
                            height 75px
                            cursor pointer
                            &:first-child
                                bottom 40px
                                left 247px
                                &:hover:before
                                    color #0089ff
                                &:before
                                    position absolute
                                    bottom: -28px
                                    font-size 18px
                                    color white
                                    display: inline-block
                                    width 77px
                                    content '企业APP'
                            &:nth-child(2)
                                bottom: 127px;
                                left: 66px;
                                &:hover:before
                                    color #0089ff
                                &:before
                                    position absolute
                                    bottom: 24px
                                    right 84px
                                    font-size 18px
                                    color white
                                    display: inline-block
                                    width 77px
                                    content '阿里钉钉'
                            &:nth-child(3)
                                top: 127px;
                                right: 66px;
                                &:hover:before
                                    color #0089ff
                                &:before
                                    position absolute
                                    bottom: 24px
                                    left 76px
                                    font-size 18px
                                    color white
                                    display: inline-block
                                    width 77px
                                    content '服务号'
                            &:nth-child(4)
                                top 40px
                                left 247px
                                &:hover:before
                                    color #0089ff
                                &:before
                                    position absolute
                                    top: -28px
                                    font-size 18px
                                    color white
                                    display: inline-block
                                    width 77px
                                    content '办公OA'
                            &:nth-child(5)
                                bottom: 127px;
                                right: 66px;
                                &:hover:before
                                    color #0089ff
                                &:before
                                    position absolute
                                    bottom: 24px
                                    left 84px
                                    font-size 18px
                                    color white
                                    display: inline-block
                                    width 77px
                                    content '企业网站'
                            &:nth-child(6)
                                top 127px
                                left 66px
                                &:hover:before
                                    color #0089ff
                                &:before
                                    position absolute
                                    bottom: 24px
                                    right 84px
                                    font-size 18px
                                    color white
                                    display: inline-block
                                    width 77px
                                    content '企业微信'
                .phone
                    position relative
                    width 258px
                    height 531px
                    float right
                    #typing
                        position absolute
                        width 100%
                        top 540px
                        color white
                    .phone-screen
                        width 226px
                        height 402px
                        position absolute
                        top 64px
                        left 16px
                        transition 0.3s ease
                        background-size cover
            .tile
                display inline-block
                margin-top 60px
            .tile-cont
                margin-top 20px
                margin-bottom 55px
                font-size 36px
                color white
                font-weight bold

    .case
        text-align center
        background-color #f2f2f2
        table
            margin 100px auto 0
            padding-bottom 100px
            border-collapse separate
            border-spacing 5px
            empty-cells show
            tr
                height 88px
            td
                height 88px
                line-height 88px
                width 120px
                img
                    filter saturate(80%)
                    &.move
                        transform translateX(60px)
                    &:hover
                        filter saturate(120%)
                        box-shadow 0px 0px 20px #ccc
                        transition 0.3s
        .tile
            display inline-block
            margin-top 60px
        .tile-cont
            margin-top 20px
            margin-bottom 55px
            font-size 36px
            color black
            font-weight bold

    @keyframes circle-opacity {
        from {
            opacity: 1;
            transform: scale(1);
        }
        to {
            opacity: 0;
            transform: scale(6)
        }
    }

    .more-btn
        margin-top 20px
        display inline-block
        height 36px
        .btn
            display block
        .btn1
            display none
        &:hover
            .btn
                display none
            .btn1
                display block

    div.control
        height 8px
        position absolute
        right 50%
        bottom 30px
        li.control-item
            display inline-block
            width 16px
            height 16px
            background white
            margin-right 8px
            border-radius 8px
            &.active
                background #0d90ff
</style>